var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network"},[_c('img',{attrs:{"src":require("@/assets/private.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('k_167475')))]),_vm._v(" "),_c('span',{staticClass:"descript"},[_vm._v(_vm._s(_vm.$t('k_336136')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }